<template>
  <div class="products-errors-view">
    <div v-if="productImports">
      <dl
         v-for="entry in productImports.entries"
        :key="entry.origin"
      >
        <dd>Provider</dd>
        <dt>{{entry.origin}}</dt>
        <dd>File:</dd>
        <dt>
          <router-link
            :to="{ name: 'import-report', params: { id: entry.importId }}"
          >
            {{entry.fileName}}
          </router-link>
        </dt>
        <dd>Rohdaten:</dd>
        <dt class="preformatted">{{prettify(entry.source)}}</dt>
      </dl>
    </div>
  </div>
</template>

<script>
import Authentication from '@/mixins/Authentication';
import productImportsQuery
  from '@/api/queries/product-imports.graphql';

export default {
  name: 'products-imports-view',
  mixins: [
    Authentication,
  ],
  methods: {
    prettify(source) {
      console.log(JSON.stringify(JSON.parse(source), undefined, 2)); // eslint-disable-line
      return JSON.stringify(JSON.parse(source), undefined, 2);
    },
  },
  apollo: {
    productImports: {
      query: productImportsQuery,
      variables() {
        return {
          search: this.$attrs.product.articleNumber,
        };
      },
      fetchPolicy: 'network-only',
      loadingKey: 'loading',
      skip() {
        return !this.isAuthenticated;
      },
    },
  },
};
</script>

<style scoped>
dt.preformatted {
  background-color: #eee;
  color: black;
  font-weight: 300;
  white-space: pre-wrap;
  font-family: monospace;
}
</style>



// WEBPACK FOOTER //
// ImportsView.vue?1f60990e